import swal from "sweetalert2";
import * as angular from "angular";
import * as PropTypes from "prop-types";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import * as ReactDOMServer from "react-dom/server";
import * as _ from "underscore";
import uuidv4 from "uuidv4";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import * as tus from "tus-js-client";
import "./obto-data-service";
import * as NProgress from "nprogress";
import moment from "moment-timezone";
import * as async from "async";
import "jquery-steps/build/jquery.steps.min";
import "bootstrap-datepicker/dist/js/bootstrap-datepicker.min";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css";
import "dropzone/dist/min/dropzone.min.css";
import * as print from "print-js";
import * as Actions from "./actions/counter";
import "showdown/dist/showdown.min";
import "ng-showdown/dist/ng-showdown.min";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Provider } from "react-redux";
import store from "./store";
// import { AgGridReact } from 'ag-grid-react';
// import { heart, share } from "ionicons/icons";
import ColumnSelect from "react-column-select";
import StepWizard from "react-step-wizard";
import Draggable, { DraggableCore } from "react-draggable";
import { Stepper, Step } from "react-form-stepper";
import { loadStripe } from "@stripe/stripe-js";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import { encode as HTMLEncode } from "he";
import markdownIt from "markdown-it";
import hljs from "highlight.js";
import DailyIframe from "@daily-co/daily-js";
import * as dco from "@daily-co/daily-react";
import { RecoilRoot } from "recoil";
import * as antd from "antd";
import * as antdPlots from "@ant-design/plots";
import * as antdIcons from "@ant-design/icons";
import * as antv from "@antv/g6";
import cronstrue from "cronstrue";
import http from "./interceptors/httpInterceptor";
import { format } from "prettier/standalone";
import * as prettierPluginBabel from "prettier/plugins/babel";
import * as prettierPluginEstree from "prettier/plugins/estree";
import * as lucidereact from "lucide-react";
import HorizontalNavigation from "./components/HorizontalNavigation";
import Timeline, {
  TimelineMarkers,
  TodayMarker,
  CustomMarker,
  CursorMarker,
} from "react-calendar-timeline";
import CheckboxTree from "react-checkbox-tree";
import * as reactFlow from "@xyflow/react";
const __obto = typeof globalThis !== "undefined" ? globalThis : window;
__obto.__OBTO_TPL__ = __obto.__OBTO_TPL__ || {
  globalsAttached: false,
  compiledLinkFnCache: new Map(), // key: `${templateName}:${version}` => linkFn
  scriptFactoryCache: new Map(), // key: `${mode}:${scriptText}` => factoryFn
};
const globalOptions: any = {
  global: {
    useUTC: true,
  },
  chart: {
    style: {
      fontFamily: "Lato,sans-serif",
    },
  },
  credits: {
    enabled: false,
  },
  colors: [
    "rgb(255, 99, 132)",
    "rgb(255, 159, 64)",
    "rgb(255, 205, 86)",
    "rgb(75, 192, 192)",
    "rgb(54, 162, 235)",
    "rgb(153, 102, 255)",
    "rgb(201, 203, 207)",
  ],
  title: {
    text: "Preparing widget...",
    align: "left",
    x: 78,
    margin: 5,
    style: {
      color: "rgba(0,0,0,1.0)",
    },
  },
  subtitle: {
    text: "",
    align: "left",
    x: 80,
  },
  xAxis: {
    title: {
      text: "",
      rotation: 0,
      textAlign: "center",
      style: {
        color: "rgba(0,0,0,1.0)",
      },
    },
    labels: {
      style: {
        color: "rgba(0,0,0,1.0)",
        fontSize: "9px",
      },
    },
    lineWidth: 0.5,
    lineColor: "#333",
    tickColor: "#333",
    tickLength: 3,
    tickWidth: 0.5,
    gridLineWidth: 0,
    gridLineColor: "#eee",
  },
  yAxis: {
    title: {
      text: "",
      rotation: 0,
      textAlign: "right",
      style: {
        color: "rgba(0,0,0,1.0)",
      },
    },
    labels: {
      style: {
        color: "rgba(0,0,0,1.0)",
        fontSize: "9px",
      },
    },
    lineWidth: 0.5,
    lineColor: "#333",
    tickColor: "#333",
    tickLength: 3,
    tickWidth: 0.5,
    gridLineWidth: 0.5,
    gridLineColor: "#eee",
  },
  plotOptions: {
    area: {
      //stacking:'normal',
      lineWidth: 1,
      marker: {
        enabled: false,
        symbol: "circle",
        radius: 4,
      },
    },
    arearange: {
      lineWidth: 1,
    },
    areaspline: {
      //stacking:'normal',
      lineWidth: 1,
      marker: {
        enabled: false,
        symbol: "circle",
        radius: 4,
      },
    },
    areasplinerange: {
      lineWidth: 1,
    },
    boxplot: {
      groupPadding: 0.05,
      pointPadding: 0.05,
      fillColor: "rgba(255,255,255,.75)",
    },
    bubble: {
      minSize: "0.25%",
      maxSize: "17%",
    },
    column: {
      stacking: "normal",
      groupPadding: 0.05,
      pointPadding: 0.35,
    },
    columnrange: {
      groupPadding: 0.05,
      pointPadding: 0.05,
    },
    errorbar: {
      // groupPadding: 0.05,
      pointPadding: 0.05,
      showInLegend: true,
    },
    line: {
      lineWidth: 2,
      marker: {
        enabled: false,
        symbol: "circle",
        radius: 4,
      },
    },
    scatter: {
      marker: {
        symbol: "circle",
        radius: 5,
      },
    },
    spline: {
      lineWidth: 2,
      marker: {
        enabled: false,
        symbol: "circle",
        radius: 4,
      },
    },
    series: {
      shadow: false,
    },
  },
};

Highcharts.setOptions(globalOptions);

angular
  .module("obto.data.dashboard", ["ng-showdown", "obto.data.service"])
  .controller("PageController", [
    "$scope",
    "$http",
    "$routeParams",
    "$log",
    "pageService",
    "$location",
    "$route",
    "$timeout",
    "$rootScope",
    "$uibModal",
    "CS",
    "$ngRedux",
    function (
      $scope,
      $http,
      $routeParams,
      $log,
      pageService,
      $location,
      $route,
      $timeout,
      $rootScope,
      $uibModal,
      CS,
      $ngRedux
    ) {
      var schemaSize = 0;
      $scope.filterModal = {};
      $scope.schema = {};
      $scope.events = [];
      $scope.selectedStudent = "Divyansh Verma";
      $scope.CS = CS;
    },
  ])
  .filter("scheduleFilter", [
    function () {
      return function (items, day, period) {
        if (!_.isUndefined(items) && items.length !== 0) {
          var filtered = [];
          var found = false;
          angular.forEach(items, function (e) {
            if (e.day === day && e.period === period) {
              // console.log("parentApp" + day + ": " + period);
              found = true;
              // @ts-ignore
              filtered.push(e);
            }
          });
          if (!found) {
            // @ts-ignore
            filtered.push({
              subject: {
                label: "",
              },
              class: {
                label: "",
              },
            });
          }
          return filtered;
        }
      };
    },
  ])
  .controller("ModalInstanceCtrl4", [
    "$uibModalInstance",
    "$scope",
    "$rootScope",
    "$location",
    "$http",
    "$localstorage",
    "$timeout",
    "$log",
    "parentScope",
    "name",
    "_collection",
    "appName",
    function (
      $uibModalInstance,
      $scope,
      $rootScope,
      $location,
      $http,
      $localstorage,
      $timeout,
      $log,
      parentScope,
      name,
      _collection,
      appName
    ) {
      if (name === "showsubform.html") {
        setTimeout(function () {
          $rootScope.$emit("event.render.subform.started", {
            collection: _collection,
            type: "list",
            filter: { app: appName },
          });
        }, 700);
      }
      $scope.ok = function () {};
      $scope.destoryMember = function () {
        setTimeout(function () {
          $rootScope.$emit("event.remove.subform");
        }, 500);
      };
      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
        $scope.destoryMember();
      };
    },
  ])
  .directive("obtoTemplate", [
    "$rootScope",
    "$compile",
    "$http",
    "$window",
    "$templateCache",
    "$timeout",
    "$routeParams",
    "$anchorScroll",
    "$location",
    "$uibModal",
    "API",
    "async",
    "$localstorage",
    "$templateRequest",
    "$log",
    "OB",
    "pageService",
    "$showdown",
    "$ngRedux",
    "$route",
    function (
      $rootScope,
      $compile,
      $http,
      $window,
      $templateCache,
      $timeout,
      $routeParams,
      $anchorScroll,
      $location,
      $uibModal,
      API,
      async,
      $localstorage,
      $templateRequest,
      $log,
      OB,
      pageService,
      $showdown,
      $ngRedux,
      $route
    ) {
      return {
        restrict: "E",
        replace: true,
        scope: {
          name: "@",
          parentData: "=",
          options: "@",
          time: "=",
          cs: "=",
          modifiedValues: "=",
          devControls: "@",
          isChild: "@",
        },
        controllerAs: "templateCtrl",
        templateUrl: $rootScope.viewFiles + "/obtemplatebase.html",
        transclude: true,
        controller: ["$ngRedux", "$scope", TemplateController],
        link: function (scope: any, element, attrs) {
          scope.fixTemplateName = (name) => {
            return name.replace(".", "");
          };
          // -------------------------
          // 0) Attach globals ONCE
          // -------------------------
          if (!__obto.__OBTO_TPL__.globalsAttached) {
            __obto.__OBTO_TPL__.globalsAttached = true;

            Object.assign(__obto, {
              Stepper,
              Step,
              Draggable,
              DraggableCore,
              saveAs,
              XLSX,
              StepWizard,
              ColumnSelect,
              Timeline,
              TimelineMarkers,
              TodayMarker,
              CustomMarker,
              createRoot,
              CursorMarker,
              CheckboxTree,
              ReactDOM,
              ReactDOMServer,
              React,
              NProgress,
              pageService,
              moment,
              uuidv4,
              Highcharts,
              HighchartsReact,
              Provider,
              store,
              _,
              swal,
              print,

              markdownIt,
              HTMLEncode,
              hljs,
              fetchEventSource,
              DailyIframe,
              dco,
              RecoilRoot,
              antd,
              antdPlots,
              antdIcons,
              tus,
              loadStripe,
              antv,
              http,
              cronstrue,
              format,
              prettierPluginBabel,
              prettierPluginEstree,
              lucidereact,
              reactFlow,
            });
          }

          // -------------------------
          // 1) Keep your existing setup
          // -------------------------
          let baseURL = "/o/template.bto/";
          let msBaseURL = "/ms/v2/template.bto/";
          let tplURL = "";
          let templateConnected = false;
          let deregister1 = () => {};
          let scripts = [];

          let injectStyleText = "";
          let styleEl = null;

          const templateName = scope.name;
          const isChild = scope.isChild || false;

          tplURL = baseURL + templateName + "?v=" + $rootScope.oversion;
          let templateVersionUrl = "/templateversion.bto/" + templateName;

          if (templateName === "brand_login") {
            templateVersionUrl = "/ms/v2/templateversion.bto/" + templateName;
            tplURL = msBaseURL + templateName + "?v=" + $rootScope.oversion;
          }

          const allProps = $localstorage.getObject("ob.props");

          const o = {
            root: $rootScope,
            scope: scope,
            timeout: $timeout,
            http: $http,
            window: $window,
            moment: moment,
            pageService: pageService,
            _: _,
            routeParams: $routeParams,
            async: async,
            beautify: {},
            scrollTo: $anchorScroll,
            location: $location,
            modal: $uibModal,
            API: API,
            localStorage: $localstorage,
            swal: swal,
            log: $log,
            service: OB,
            M: scope.cs || {},
            $showdown: $showdown,
            $ngRedux: $ngRedux,
            PropTypes: PropTypes,
            React: React,
            ReactDOM: ReactDOM,
            ReactDOMServer: ReactDOMServer,
            Highcharts: Highcharts,
            NProgress: NProgress,
            tus,
            compile: $compile,
          };

          // -------------------------
          // 2) Fast, cached script runner
          // -------------------------
          const getScriptFactory = (scriptText, compiledMode) => {
            const mode = compiledMode ? "compiled" : "raw";
            const key = mode + ":" + scriptText;

            const cache = __obto.__OBTO_TPL__.scriptFactoryCache;
            if (cache.has(key)) return cache.get(key);

            // Create the wrapper ONCE. We still "execute" per template render, but we avoid re-parsing.
            let factoryFn;
            if (compiledMode) {
              factoryFn = new Function(
                `"use strict";
         try { ${scriptText} ; return (typeof _func === "function") ? _func() : null; }
         catch (err) { return { __err: err }; }`
              );
            } else {
              factoryFn = new Function(
                `"use strict";
         try { ${scriptText} }
         catch (err) { return { __err: err }; }`
              );
            }

            cache.set(key, factoryFn);
            return factoryFn;
          };

          const attachScripts = (loads) => {
            if (!Array.isArray(loads) || loads.length === 0) return;

            for (let i = 0; i < loads.length; i++) {
              const value = loads[i];
              const useCompiled = !!(
                allProps["co.obto.scripts.use.compiled"] && value.compiled
              );
              const scriptText = useCompiled
                ? value.compiled.code
                : value.script;

              try {
                const factory = getScriptFactory(scriptText, useCompiled);
                const produced = factory();

                if (produced && produced.__err) {
                  console.log(templateName, produced.__err);
                  continue;
                }

                // Preserve your original intent: scripts typically return a function(o)
                if (typeof produced === "function") {
                  produced(o);
                }
              } catch (e) {
                $log.info(templateName + ":::::" + scriptText);
                console.error(e);
              }
            }
          };

          // -------------------------
          // 3) Render pipeline: compile-cache + style node + defer scripts
          // -------------------------
          const ensureStyleEl = () => {
            if (styleEl) return styleEl;
            styleEl = document.createElement("style");
            element[0].prepend(styleEl);
            return styleEl;
          };
          const compiledCache = __obto.__OBTO_TPL__.compiledLinkFnCache;

          // const renderTemplateData = (data) => {
          //   // data: { html, style, loadscripts, version }
          //   // Clean previous DOM BUT keep the styleEl we control
          //   element.empty();
          //   styleEl = null;

          //   if (data && data.style) {
          //     ensureStyleEl().textContent = data.style;
          //   }

          //   const versionKey =
          //     data && data.version ? data.version : "noversion";
          //   const cacheKey = `${templateName}:${versionKey}`;

          //   const compiledCache = __obto.__OBTO_TPL__.compiledLinkFnCache;
          //   let linkFn = compiledCache.get(cacheKey);

          //   if (!linkFn) {
          //     // Compile ONCE per template+version
          //     linkFn = $compile(data.html);
          //     compiledCache.set(cacheKey, linkFn);
          //   }

          //   // Link and append
          //   const content = linkFn(scope);
          //   element.append(content);

          //   // Defer scripts so browser can paint the HTML first
          //   scripts = data.loadscripts || [];
          //   $timeout(() => attachScripts(scripts), 0, false);

          //   // Subscribe logic (ensure we don't leak)
          //   deregister1();
          //   templateConnected = false;

          //   deregister1 = $ngRedux.subscribe(() => {
          //     const state = $ngRedux.getState();
          //     if (
          //       state.login.socketStatus &&
          //       state.login.socketStatus.status === "ready" &&
          //       !templateConnected
          //     ) {
          //       const channel =
          //         $rootScope.ob.domain +
          //         "/" +
          //         $rootScope.ob.user.userid +
          //         "/app/" +
          //         templateName;

          //       $window.client && $window.client.subscribe(channel);
          //       $log.info("Subscribing..." + channel);

          //       templateConnected = true;
          //     }
          //   });
          // };

          // -------------------------
          // 4) Cache strategy: paint ASAP from cache, then validate version in background
          // -------------------------
          const renderTemplateData = (data) => {
            // Always start clean
            element.empty();

            // Style handling (safe)
            if (data.style) {
              const styleEl = document.createElement("style");
              styleEl.textContent = data.style;
              element[0].appendChild(styleEl);
            }

            const versionKey = data.version || "noversion";
            const cacheKey = `${templateName}:${versionKey}`;

            // ✅ Cache ONLY the link function
            let linkFn = compiledCache.get(cacheKey);
            if (!linkFn) {
              linkFn = $compile(data.html);
              compiledCache.set(cacheKey, linkFn);
            }

            // ✅ ALWAYS generate fresh DOM
            const childScope = scope.$new(false); // IMPORTANT
            const dom = linkFn(childScope);

            element.append(dom);

            // Defer scripts (paint first)
            $timeout(() => attachScripts(data.loadscripts || []), 0, false);

            // Redux subscription safety
            deregister1();
            templateConnected = false;

            deregister1 = $ngRedux.subscribe(() => {
              const state = $ngRedux.getState();
              if (
                state.login.socketStatus?.status === "ready" &&
                !templateConnected
              ) {
                const channel = `${$rootScope.ob.domain}/${$rootScope.ob.user.userid}/app/${templateName}`;

                $window.client?.subscribe(channel);
                templateConnected = true;
              }
            });
          };
          
          const readLocal = () =>
            $localstorage.getObject("template-" + templateName) || null;
          const writeLocal = (data) =>
            $localstorage.setObject("template-" + templateName, data);

          const fetchRemoteTemplate = () =>
            $http
              .get(tplURL, { cache: $templateCache })
              .then((resp) => resp.data);

          const fetchRemoteVersion = () =>
            $http
              .get(templateVersionUrl)
              .then((resp) => resp.data && resp.data.version);

          const paintFromCacheIfPossible = () => {
            const cached = readLocal();
            if (cached && cached.html) {
              renderTemplateData(cached);
              return true;
            }
            return false;
          };

          // 4a) Paint cached immediately (no version call gating)
          const hadCache = paintFromCacheIfPossible();

          // 4b) Version validation in parallel
          fetchRemoteVersion()
            .then((remoteVersion) => {
              const existing = readLocal();
              const localVersion = existing && existing.version;

              // If we had no cache OR versions differ, fetch and swap
              if (
                !hadCache ||
                !localVersion ||
                localVersion !== remoteVersion
              ) {
                return fetchRemoteTemplate().then((data) => {
                  // Ensure version is stored consistently
                  data.version =
                    remoteVersion || data.version || new Date().toISOString();
                  writeLocal(data);
                  renderTemplateData(data);
                });
              }

              // If versions match and we already painted cache, we’re done.
              return null;
            })
            .catch((err) => {
              // If version check fails, fall back to remote template only if nothing painted
              if (!hadCache) {
                fetchRemoteTemplate().then((data) => {
                  writeLocal(data);
                  renderTemplateData(data);
                });
              }
              console.error(err);
            });

          // -------------------------
          // 5) Reload handler: prevent leaks + repaint
          // -------------------------
          const deregister2 = $rootScope.$on(
            "event.obtotemplate.reload",
            function () {
              deregister1();
              templateConnected = false;

              fetchRemoteTemplate().then((data) => {
                // if your backend returns version in payload, keep it; otherwise keep local version semantics
                writeLocal(data);
                renderTemplateData(data);
              });
            }
          );

          // -------------------------
          // 6) Destroy: unsubscribe cleanly
          // -------------------------
          const deregister4 = scope.$on("$destroy", function () {
            deregister1();
            deregister2();
            deregister4();

            const channel =
              $rootScope.ob.domain +
              "/" +
              $rootScope.ob.user.userid +
              "/app/" +
              templateName;

            $log.info("Unsubscribing..." + channel);
            $window.client && $window.client.unsubscribe(channel);

            // If/when you re-enable React mounts, unmount here.
            // currentAppDevZoneRoot?.unmount?.();
            // currentAppDevZoneRoot = null;
          });

          // -------------------------
          // 7) Keep your title broadcast logic (unchanged)
          // -------------------------
          const targetPages = [
            "ob-connect",
            "sofos-notice-board",
            "imitate",
            "ob-domains",
            "switchdomain",
            "changeset",
            "potential-functionality-1",
            "potential-functionality-2",
          ];

          !isChild &&
            setTimeout(function () {
              if (targetPages.indexOf(templateName) === -1) {
                let title = templateName.replace(/[_-]/g, " ");
                title = title.replace("pltf", "").trim();
                title = title.replace(".html", "").trim();
                title = title.replace("v2", "").trim();
                title = title.charAt(0).toUpperCase() + title.slice(1);
                $rootScope.$broadcast("event:titlechanged", title);
              }
            }, 300);
        },
      };
    },
  ])
  // .directive("obtoTemplate", [
  //   "$rootScope",
  //   "$compile",
  //   "$http",
  //   "$window",
  //   "$templateCache",
  //   "$timeout",
  //   "$routeParams",
  //   "$anchorScroll",
  //   "$location",
  //   "$uibModal",
  //   "API",
  //   "async",
  //   "$localstorage",
  //   "$templateRequest",
  //   "$log",
  //   "OB",
  //   "pageService",
  //   "$showdown",
  //   "$ngRedux",
  //   "$route",
  //   function(
  //     $rootScope,
  //     $compile,
  //     $http,
  //     $window,
  //     $templateCache,
  //     $timeout,
  //     $routeParams,
  //     $anchorScroll,
  //     $location,
  //     $uibModal,
  //     API,
  //     async,
  //     $localstorage,
  //     $templateRequest,
  //     $log,
  //     OB,
  //     pageService,
  //     $showdown,
  //     $ngRedux,
  //     $route
  //   ) {
  //     return {
  //       restrict: "E",
  //       replace: true,
  //       scope: {
  //         name: "@",
  //         parentData: "=",
  //         options: "@",
  //         time: "=",
  //         cs: "=",
  //         modifiedValues: "=",
  //         devControls: "@",
  //         isChild: "@",
  //       },
  //       controllerAs: "templateCtrl",
  //       templateUrl: $rootScope.viewFiles + "/obtemplatebase.html",
  //       transclude: true,
  //       controller: ["$ngRedux", "$scope", TemplateController],
  //       link: function(scope: any, element, attrs) {
  //         Object.assign(global, {
  //           Stepper,
  //           Step,
  //           Draggable,
  //           DraggableCore,
  //           saveAs,
  //           XLSX,
  //           StepWizard,
  //           ColumnSelect,
  //           Timeline,
  //           TimelineMarkers,
  //           TodayMarker,
  //           CustomMarker,
  //           createRoot,
  //           CursorMarker,
  //           CheckboxTree,
  //           // heart,
  //           // share,
  //           ReactDOM,
  //           ReactDOMServer,
  //           React,
  //           NProgress,
  //           pageService,
  //           moment,
  //           uuidv4,
  //           Highcharts,
  //           HighchartsReact,
  //           Provider,
  //           store,
  //           _,
  //           swal,
  //           print,
  //         });
  //         Object.assign(global, {
  //           markdownIt,
  //           HTMLEncode,
  //           hljs,
  //           fetchEventSource,
  //           DailyIframe,
  //           dco,
  //           RecoilRoot,
  //           antd,
  //           antdPlots,
  //           antdIcons,
  //           tus,
  //           loadStripe,
  //           antv,
  //           http,
  //           cronstrue,
  //           format,
  //           prettierPluginBabel,
  //           prettierPluginEstree,
  //           lucidereact,
  //           reactFlow
  //         });

  //         let baseURL = "/o/template.bto/";
  //         let msBaseURL = "/ms/v2/template.bto/";
  //         let tplURL = "";
  //         let templateLoader;
  //         // @ts-ignore
  //         let ScriptLoader = scope.cs || {};
  //         // @ts-ignore
  //         let isChild = scope.isChild || false;
  //         // @ts-ignore
  //         let parentData = scope.parentData;
  //         // @ts-ignore
  //         const templateName = scope.name;
  //         const normalizedTemplateName = templateName.replace(".", "");
  //         const o = {
  //           root: $rootScope,
  //           scope: scope,
  //           timeout: $timeout,
  //           http: $http,
  //           window: $window,
  //           moment: moment,
  //           pageService: pageService,
  //           _: _,
  //           routeParams: $routeParams,
  //           async: async,
  //           beautify: {},
  //           scrollTo: $anchorScroll,
  //           location: $location,
  //           modal: $uibModal,
  //           API: API,
  //           localStorage: $localstorage,
  //           swal: swal,
  //           log: $log,
  //           service: OB,
  //           M: ScriptLoader,
  //           $showdown: $showdown,
  //           $ngRedux: $ngRedux,
  //           PropTypes: PropTypes,
  //           React: React,
  //           ReactDOM: ReactDOM,
  //           ReactDOMServer: ReactDOMServer,
  //           Highcharts: Highcharts,
  //           NProgress: NProgress,
  //           tus,
  //           compile: $compile,
  //         };
  //         let fetch = false;
  //         let injectStyle = "";
  //         let templateConnected = false;
  //         let deregister1 = () => {};
  //         let allProps = $localstorage.getObject("ob.props");
  //         let currentAppDevZoneRoot;

  //         const attachScripts = (scripts) => {
  //           // const scripts = response.data.loadscripts;
  //           let USE_SCRIPT = "";
  //           for (let index = 0, len = scripts.length; index < len; ++index) {
  //             const value = scripts[index];
  //             if (allProps["co.obto.scripts.use.compiled"] && value.compiled) {
  //               USE_SCRIPT = value.compiled.code;
  //               try {
  //                 // @ts-ignore
  //                 new Function(
  //                   "try { " +
  //                     USE_SCRIPT +
  //                     " return _func(); } catch(err) { console.log(" +
  //                     templateName +
  //                     ", err)}"
  //                 )()(o); //new Function(value.script)()(o);
  //               } catch (e) {
  //                 $log.info(templateName + ":::::" + USE_SCRIPT);
  //                 console.error(e);
  //               }
  //             } else {
  //               USE_SCRIPT = value.script;
  //               try {
  //                 // @ts-ignore
  //                 new Function(
  //                   "try { " +
  //                     USE_SCRIPT +
  //                     " } catch(err) { console.log(" +
  //                     templateName +
  //                     ", err)}"
  //                 )()(o); //new Function(value.script)()(o);
  //               } catch (e) {
  //                 $log.info(templateName + ":::::" + USE_SCRIPT);
  //                 console.error(e);
  //               }
  //             }
  //           }
  //         };
  //         let scripts = [];
  //         const executeThis = function(_hitCache) {
  //           if (_hitCache) {
  //             templateLoader = $http.get(tplURL, { cache: $templateCache });
  //             templateLoader.then(function(response) {
  //               if (response.data.style) {
  //                 injectStyle = "<style>" + response.data.style + "</style>";
  //               }

  //               element.append(
  //                 $compile(injectStyle + response.data.html)(scope)
  //               );
  //               attachScripts(response.data.loadscripts);
  //               scripts = response.data.loadscripts;
  //               $localstorage.setObject(
  //                 "template-" + templateName,
  //                 response.data
  //               );
  //             });
  //           } else {
  //             $log.info("Loading from cache..." + templateName);
  //             var cachedTemplate = $localstorage.getObject(
  //               "template-" + templateName
  //             );
  //             let USE_SCRIPT = "";

  //             if (cachedTemplate.style) {
  //               injectStyle = "<style>" + cachedTemplate.style + "</style>";
  //             }
  //             var linkFn = $compile(injectStyle + cachedTemplate.html);
  //             var content = linkFn(scope);
  //             element.append(content);
  //             scripts = cachedTemplate.loadscripts;
  //             attachScripts(cachedTemplate.loadscripts);
  //           }

  //           deregister1 = $ngRedux.subscribe(() => {
  //             let state = $ngRedux.getState();
  //             if (
  //               state.login.socketStatus &&
  //               state.login.socketStatus.status === "ready" &&
  //               !templateConnected
  //             ) {
  //               $window.client &&
  //                 $window.client.subscribe(
  //                   $rootScope.ob.domain +
  //                     "/" +
  //                     $rootScope.ob.user.userid +
  //                     "/app/" +
  //                     templateName
  //                 );
  //               $log.info(
  //                 "Subscribing..." +
  //                   ($rootScope.ob.domain +
  //                     "/" +
  //                     $rootScope.ob.user.userid +
  //                     "/app/" +
  //                     templateName)
  //               );
  //               templateConnected = true;
  //             }
  //           });
  //         };

  //         const deregister2 = $rootScope.$on(
  //           "event.obtotemplate.reload",
  //           function(e, d) {
  //             element.html("");
  //             executeThis(true);
  //           }
  //         );

  //         const deregister4 = scope.$on("$destroy", function() {
  //           deregister1();
  //           deregister2();
  //           deregister4();
  //           $log.info(
  //             "Unsubscribing..." +
  //               ($rootScope.ob.domain +
  //                 "/" +
  //                 $rootScope.ob.user.userid +
  //                 "/app/" +
  //                 templateName)
  //           );
  //           $window.client &&
  //             $window.client.unsubscribe(
  //               $rootScope.ob.domain +
  //                 "/" +
  //                 $rootScope.ob.user.userid +
  //                 "/app/" +
  //                 templateName
  //             );
  //             // if (currentAppDevZoneRoot) {
  //             //   currentAppDevZoneRoot.unmount();
  //             //   currentAppDevZoneRoot = null;
  //             // }
  //         });

  //         // @ts-ignore
  //         tplURL = baseURL + templateName + "?v=" + $rootScope.oversion;
  //         // @ts-ignore
  //         // templateName = scope.name;
  //         //brand_login
  //         let templateVersionUrl = "/templateversion.bto/" + templateName;

  //         if (templateName === "brand_login") {
  //           templateVersionUrl = "/ms/v2/templateversion.bto/" + templateName;
  //           tplURL = msBaseURL + templateName + "?v=" + $rootScope.oversion;
  //         }

  //         scope.showDevControls = false;
  //         if (
  //           $rootScope.user &&
  //           $rootScope.user.roles &&
  //           $rootScope.user.roles.indexOf("developer") > -1
  //         ) {
  //           // @ts-ignore
  //           scope.showDevControls = true;

  //           if(currentAppDevZoneRoot){
  //             // currentAppDevZoneRoot.render(
  //             //   <DevZoneComponent name={scope.name} />
  //             // );
  //           } else {
  //             // currentAppDevZoneRoot = createRoot(document.getElementById("currentAppDevZone")).render(
  //             //   <DevZoneComponent name={scope.name} />
  //             // );
  //           }

  //         }

  //         if (scope.devControls && scope.devControls.toString() == "false") {
  //           scope.showDevControls = false;
  //         }

  //         scope.hideDevControls = function() {
  //           scope.showDevControls = false;
  //         };

  //         scope.fixTemplateName = (name) => {
  //           return name.replace(".", "");
  //         };

  //         scope.reload = () => {
  //           $route.reload();
  //         };

  //         scope.open = function(name, collection) {
  //           // console.log(name);
  //           var size = "xl";
  //           var modalInstance = $uibModal.open({
  //             templateUrl: name,
  //             controller: "ModalInstanceCtrl4",
  //             size: size,
  //             windowTopClass: "obto-modal-document right",
  //             keyboard: false,
  //             backdrop: "static",
  //             animation: false,
  //             resolve: {
  //               parentScope: function() {
  //                 return scope;
  //               },
  //               name: function() {
  //                 return name;
  //               },
  //               _collection: function() {
  //                 return collection;
  //               },
  //               appName: function() {
  //                 // @ts-ignore
  //                 return scope.name;
  //               },
  //             },
  //           });
  //           // console.log(modalInstance.result)
  //           modalInstance.result.then(
  //             function(selectedItem) {
  //               //$scope.selected = selectedItem;
  //               // console.log(selectedItem);
  //             },
  //             function() {
  //               $log.info("Modal dismissed at: " + new Date());
  //             }
  //           );
  //         };

  //         $http.get(templateVersionUrl).then(function(response) {
  //           "use strict";
  //           // tplURL = baseURL + templateName + "?v=" + response.data.version;
  //           var existing = $localstorage.getObject("template-" + templateName);
  //           if (
  //             !existing.version ||
  //             existing.version !== response.data.version
  //           ) {
  //             fetch = !fetch;
  //           }
  //           executeThis(fetch);
  //           // @ts-ignore
  //           var targetPages = [
  //             "ob-connect",
  //             "sofos-notice-board",
  //             "imitate",
  //             "ob-domains",
  //             "switchdomain",
  //             "changeset",
  //             "potential-functionality-1",
  //             "potential-functionality-2",
  //           ];
  //           !isChild &&
  //             setTimeout(function() {
  //               if (targetPages.indexOf(templateName) === -1) {
  //                 // @ts-ignore
  //                 var title = templateName.replace(/[_-]/g, " ");
  //                 title = title.replace("pltf", "").trim();
  //                 title = title.replace(".html", "").trim();
  //                 title = title.replace("v2", "").trim();
  //                 title = title.charAt(0).toUpperCase() + title.slice(1);
  //                 $rootScope.$broadcast("event:titlechanged", title);
  //               }
  //             }, 300);
  //         });

  //         // return {
  //         //     pre: function preLink( scope, element, attributes ) {
  //         //         console.log( attributes.log + ' (pre-link)'  );
  //         //     },
  //         //     post: function postLink( scope, element, attributes ) {
  //         //         console.log( attributes.log + ' (post-link)'  );
  //         //     }
  //         // };
  //       },
  //     };
  //   },
  // ])
  .directive("obtoPage", [
    "$window",
    "$timeout",
    "$compile",
    "pageService",
    "$http",
    "$routeParams",
    "$rootScope",
    "$location",
    "ribbon",
    "$uibModal",
    "API",
    "$localstorage",
    "$log",
    "$anchorScroll",
    "OB",
    "$route",
    "$document",
    function (
      $window,
      $timeout,
      $compile,
      pageService,
      $http,
      $routeParams,
      $rootScope,
      $location,
      ribbon,
      $uibModal,
      API,
      $localstorage,
      $log,
      $anchorScroll,
      OB,
      $route,
      $document
    ) {
      return {
        replace: true,
        restrict: "E",
        templateUrl:
          $rootScope.viewFiles + "/page-base.html?v=" + $rootScope.oversion,
        scope: {
          cs: "=",
          name: "@",
        },
        link: function ($scope: any, element, attrs) {
          var schemaSize = 0;
          $scope.ready = false;
          var allPromises = [];
          $scope.rows = [];
          var rows = [];
          let _2first = null;
          // @ts-ignore
          $scope.pageName = $scope.name || $routeParams.pagename;
          $scope.filterModal = {};
          $scope.schema = {};
          $scope.events = [];
          $scope.selectedStudent = "Divyansh Verma";
          $scope.gridOptions = {
            embedded: true,
          };
          $scope.decode = function (val) {
            var returnThis = val.toString();
            if (
              !_.isUndefined(val) &&
              returnThis.startsWith("{{") &&
              returnThis.endsWith("}}")
            ) {
              returnThis = returnThis.substring(2, returnThis.indexOf("}}"));
              return _.isUndefined($rootScope.user[returnThis])
                ? val
                : $rootScope.user[returnThis];
            }
            return val;
          };
          var controlFunction = function () {
            return function (H, id) {
              // @ts-ignore
              H.Chart.prototype.callbacks.push(function (chart) {
                H.addEvent(chart.container, "click", function (e) {
                  e = chart.pointer.normalize();
                });
                H.addEvent(chart.xAxis[0], "afterSetExtremes", function (e) {});
              });
            };
          };
          const deregister1 = $scope.$on("$routeUpdate", function (e, current) {
            $timeout(function () {
              $route.reload();
            }, 600);
          });

          $scope.chartConfigs = {};
          var listConfigs = {};
          var chartConfigs = {};
          $scope.listConfigs = {};
          $scope.chartTitle = "";
          // @ts-ignore
          $scope.isChart = function (val) {
            return !!val;
          };
          // @ts-ignore
          $scope.getUrl = function (name) {
            return "/o/template.bto?name=" + name;
          };
          const deregister2 = $scope.$watch(
            "chartTitle",
            function (n, o) {},
            true
          );

          $scope.reflow = function () {
            $scope.$broadcast("highchartsng.reflow");
          };

          $scope.getColumns = function (n) {
            return new Array(parseInt(n));
          };
          if ($routeParams.thisIsLast) {
            delete $routeParams.thisIsLast;
          }
          $scope.getColumns = function (n) {
            try {
              if (n) {
                // @ts-ignore
                // @ts-ignore
                return new Array(parseInt(n));
              }
            } catch (e) {
              console.log("Please refersh the page : " + e);
            }
          };
          $scope.fetchConfigs = function (schema, outerKey, innerKey, row) {
            return new Promise(function (resolve, reject) {
              var _chartConfig = schema.chart.chartConfig;
              if (
                typeof _chartConfig !== "object" &&
                !_.isUndefined(_chartConfig)
              ) {
                pageService.getbyid(schema.chart.chartConfig, function (data) {
                  try {
                    // @ts-ignore
                    var config = JSON.parse(data.rows[0].script); //JSON.parse(data.rows[0].script);//JSON.parse(
                    if (schema.chart.isChart) {
                      if (
                        config.plotOptions &&
                        config.plotOptions.series &&
                        config.plotOptions.series.point
                      ) {
                        // @ts-ignore
                        // @ts-ignore
                        config.plotOptions.series.point.events.click =
                          new Function(
                            config.plotOptions.series.point.events.click
                          );
                      }
                      var HID = schema.chart.id;
                      var id = data.rows[0]._id;
                      chartConfigs[HID] = config;
                      // @ts-ignore
                      if (
                        config.series instanceof Array &&
                        typeof config.series[0] === "string"
                      ) {
                        var series_1 = [];
                        config.series.forEach(function (val) {
                          pageService.getbydata(
                            val,
                            function (_data) {
                              // @ts-ignore
                              series_1.push(_data);
                            },
                            $.param($routeParams)
                          );
                        });
                        // if (!config.xAxis) {
                        //     chartConfigs[HID].xAxis.categories = []
                        // }
                        // "series": {
                        //     "pointRange": 86400000,
                        //         "stacking": "undefined",
                        //         "dataLabels": {
                        //         "enabled": true,
                        //             "y": 20
                        //     },
                        //     "pointWidth": 10
                        // },
                        chartConfigs[schema.chart.id].series = series_1;
                      }
                      var HElement = $(".dashboard-container");
                      var newH = 350; //HElement.height();
                      var newW = HElement.width() / row.size;
                      // console.log(newW, HElement.width(), HElement.outerWidth());
                      var newCalculatedW = newW - newW * 0.02;
                      chartConfigs[HID].chart.height = newH;
                      chartConfigs[HID].chart.width = newCalculatedW;
                      $scope.chartConfigs = chartConfigs;
                      // @ts-ignore
                      // controlFunction()(Highcharts, id);
                      // console.log('$scope.chartConfigs', $scope.chartConfigs);
                      resolve({});
                    }
                    if (schema.chart.isList) {
                      listConfigs[schema.chart.id] = config.chart;
                      $scope.listConfigs = listConfigs;
                      // console.log('$scope.listConfigs', $scope.listConfigs);
                      resolve({});
                    }
                    if (schema.chart.isHtmlTemplate) {
                      resolve({});
                    }
                  } catch (e) {
                    console.error(e);
                    resolve({});
                  }
                });
              } else {
                resolve({});
              }
            });
          };
          NProgress.start();

          const deregister3 = $timeout(function () {
            $http
              .get("/o/page.bto/" + $scope.pageName)
              .then(function (response) {
                rows = response.data.structure.schema;
                async.forEachOf(
                  rows,
                  function (row, outerKey, cb) {
                    if (row.widgets.length) {
                      async.forEachOf(
                        row.widgets,
                        function (widget, innerKey, _cb) {
                          // console.log(widget);
                          allPromises.push(
                            $scope.fetchConfigs(widget, outerKey, innerKey, row)
                          );
                          _cb();
                        },
                        function (err) {
                          cb();
                        }
                      );
                    } else {
                      cb();
                    }
                  },
                  function (err) {
                    Promise.all(allPromises).then(function (values) {
                      // console.log(values);
                      setTimeout(function () {
                        $scope.ready = true;
                        $scope.rows = rows;
                        console.log("All Done");
                        $scope.$digest();
                        NProgress.done();
                        _2first = document.querySelector("#content");
                        const _registerEvent = (e) => {
                          if (_2first.scrollTop > 70) {
                            // _2first.addClass("fix-search");
                            // console.log(_2first.scrollTop);
                            $rootScope.$broadcast("event:past70");
                          } else {
                            // _2first.removeClass("fix-search");
                          }
                        };
                        _2first.addEventListener("scroll", _registerEvent);
                      }, 300);
                    });
                  }
                );
              });
          }, 500);

          const deregister4 = $scope.$on("$destroy", () => {
            deregister1();
            deregister2();
            deregister4();
            clearTimeout(deregister3);
            $log.info("Removed all list listeners");
          });
        },
      };
    },
  ])
  // Add directive for horizontal navigation
  .directive("horizontalNavigation", [
    "$compile",
    "$rootScope",
    "$timeout",
    function ($compile, $rootScope, $timeout) {
      return {
        restrict: "E",
        link: function (scope, element) {
          // Create a container for the React component
          const container = document.createElement("div");
          container.id = "horizontal-navigation-container";
          element.append(container);

          // Render the React component
          $timeout(function () {
            try {
              const root = createRoot(container);
              root.render(
                React.createElement(HorizontalNavigation, {
                  rootScope: $rootScope,
                })
              );
            } catch (error) {
              console.error("Error rendering HorizontalNavigation:", error);
            }
          });

          // Clean up on destroy
          scope.$on("$destroy", function () {
            if (container) {
              const root = createRoot(container);
              root.unmount();
            }
          });
        },
      };
    },
  ]);

const { FloatButton } = antd;
const DevZoneComponent = (props) => {
  const openDevZone = () => {
    if (props.name) {
      window.open(
        `${window.location.origin}/page?pagename=devzone&appname=${props.name}`,
        "_blank"
      );
    }
  };
  return <FloatButton onClick={openDevZone} tooltip={<div>DevZone</div>} />;
};

class TemplateController {
  students: any[];
  teachers: any[];
  notifystudents: any[];
  notifyteachers: any[];
  notifyteachersLabels: any[];
  classes: any[];
  main: any;
  constructor($ngRedux, $scope) {
    const unsubscribe = $ngRedux.connect(this.mapStateToThis, Actions)(this);
    $scope.$on("$destroy", unsubscribe);
    this.students = [];
    this.teachers = [];
    this.notifystudents = [];
    this.notifyteachers = [];
    this.notifyteachersLabels = [];
    this.classes = [];
    this.main = {};
  }

  mapStateToThis(state) {
    return {
      value: state.appState,
    };
  }
}

TemplateController.$inject = ["$ngRedux", "$scope"];
